<template>
    <v-container fluid>
        <prospect-form
            :model="model"
            @saved="saved"
            :isEdit="false"
        ></prospect-form>
    </v-container>
</template>

<script>
import Lead from '@/models/Lead'
import Form from './Form'

export default {
    components: {
        'prospect-form': Form,
    },

    data: () => {
        return {
            model: new Lead(),
        }
    },

    methods: {
        saved() {
            this.$router.push({ name: 'lead.index' })
        },
    },
}
</script>
